import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { formatDate } from '../../../utils/dateUtils';

const MonthDetailModal = ({ data, registerMonth, month }) => {
  if (!data || data.length === 0) {
    return <div>No data available</div>;
  }

  // Define columns for ag-grid
  const columnDefs = [
    { 
      headerName: 'Contact', 
      field: 'contact',
      cellStyle: { cursor: 'pointer' }  // Set the cursor to pointer when hovering over cells in this column
    },
    { headerName: 'Channel', field: 'channel' },
    { headerName: 'Last Order', field: 'latestOrderDate', valueFormatter: params => formatDate(params.value) },
    { headerName: 'Order Count', field: 'orderCount' },
    { headerName: 'Total Amount (JPY)', field: 'totalAmountWithDelivery', valueFormatter: params => params.value.toLocaleString() },
    { headerName: 'Total Amount (THB)', field: 'totalAmountWithRate', valueFormatter: params => params.value.toLocaleString() },
    { headerName: 'Total Weight', field: 'totalWeight', valueFormatter: params => params.value.toLocaleString() },
    { headerName: 'Weight Price(THB)', field: 'totalWeightWithRate', valueFormatter: params => params.value.toLocaleString() },
    { headerName: 'Grand Total (THB)', field: 'grandTotalCost', valueFormatter: params => params.value.toLocaleString() },
  ];

  const handleCellClicked = (event) => {
    // Check if the clicked column is 'contact'
    const field = event.colDef.field;
    if (field === 'contact') {  // Only make the 'contact' column clickable
      // Use the 'smileName' from the same row data for URL parameter
      const smileName = event.data.smileName;
      if (smileName) { // Check if smileName is present
        const url = `/customer-profile?smileName=${encodeURIComponent(smileName)}`;
        window.open(url, '_blank');
      }
    }
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <h2>Details for {month} (Register Month: {registerMonth})</h2>
      <div
        className="ag-theme-alpine"
        style={{ height: '850px', width: '100%' }}
      >
        <AgGridReact
          rowData={data}
          columnDefs={columnDefs}
          defaultColDef={{
            flex: 1,
            resizable: true,
            sortable: true,
            filter: true,
          }}
          onCellClicked={handleCellClicked}  // Add this line to enable the click functionality
        />
      </div>
    </div>
  );
};

export default MonthDetailModal;
